import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbService } from '@components/custom-auto-breadcumb/service/breadcumb-service';
import { Store } from '@ngrx/store';
import { MenuOptionsService } from '@shared/services/menu-option-service';
import { PortalMenuOptionsService } from '@shared/services/portal-menu-options.service';

@Component({
  selector: 'omc-management',
  imports: [RouterOutlet],
  templateUrl: './omc-management.html',
  styleUrl: './omc-management.scss',
})
export class OmcManagement {
  private menuOptionsService = inject(MenuOptionsService);
  private portalMenuOptionsService = inject(PortalMenuOptionsService);
  public breadcrumbService = inject(BreadcrumbService);
  public store = inject(Store);

  ngOnInit(): void {
    this.menuOptionsService.clearMenuOptions();
    this.menuOptionsService.setOptions(this.portalMenuOptionsService.getOmcManagementOptions());
  }

  ngOnDestroy() {
    this.menuOptionsService.setOptions([]);
  }
}
